// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3gkAyuDEuiL9iqTFeCCNCT"};